import React from 'react';
import { FaStickyNote } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { Button, ButtonProps } from '@tq/ui-components';
import { useIsMobile, useThemedValueSwitch } from '@tq/ui-components/dist/hooks';

import { useCanAddNote } from 'hooks';
import { showAddNoteState } from 'store';
import { Consultation } from 'types';

export type AddNoteButtonProps = ButtonProps & {
  consultation?: Consultation;
};

export const AddNoteButton: React.FC<AddNoteButtonProps> = ({
  consultation,
  ...buttonProps
}) => {
  const { t } = useTranslation('notes');
  const canAddNote = useCanAddNote(consultation);

  // This is required because the component lib does not allow breakpoints for size
  const isMobile = useIsMobile();
  const { tvs } = useThemedValueSwitch();

  const setShowAddNote = useSetRecoilState(showAddNoteState);

  const toggleAddNote = () => setShowAddNote(true);

  return canAddNote ? (
    <Button
      size={isMobile ? 'md' : 'sm'}
      minWidth='auto'
      rightIcon={<FaStickyNote />}
      width={{ base: '100%', lg: tvs({ tq: '10.375rem' }, '170px') }}
      variant='secondary'
      onClick={toggleAddNote}
      {...buttonProps}
    >
      {t('add_note', 'Add note')}
    </Button>
  ) : null;
};
